import { useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Reveal from "@/components/Reveal";
import { Icon } from "@/components/Icon";
import { TESTIMONIALS } from "@/lib/content";

const Testimonials = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: "start" });

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);

  return (
    <section className="bg-white" data-testid="testimonials">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 lg:py-28">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-8">
          <Reveal className="max-w-2xl">
            <p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-[#4B5CAB]">
              What our clients say
            </p>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-[-0.02em] text-[#2A2E7A] leading-[1.15]">
              Trusted relationships that last
            </h2>
          </Reveal>

          <div className="flex items-center gap-3">
            <button
              onClick={scrollPrev}
              data-testid="testimonial-prev"
              aria-label="Previous testimonial"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-[#2A2E7A]/15 text-[#2A2E7A] transition-colors duration-200 hover:bg-[#2A2E7A] hover:text-white hover:border-[#2A2E7A]"
            >
              <Icon name="ArrowLeft" className="h-5 w-5" />
            </button>
            <button
              onClick={scrollNext}
              data-testid="testimonial-next"
              aria-label="Next testimonial"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-[#2A2E7A]/15 text-[#2A2E7A] transition-colors duration-200 hover:bg-[#2A2E7A] hover:text-white hover:border-[#2A2E7A]"
            >
              <Icon name="ArrowRight" className="h-5 w-5" />
            </button>
          </div>
        </div>

        <Reveal delay={0.1} className="mt-14">
          <div className="overflow-hidden" ref={emblaRef}>
            <div className="flex -ml-6 lg:-ml-8">
              {TESTIMONIALS.map((t, i) => (
                <div
                  key={i}
                  className="pl-6 lg:pl-8 flex-[0_0_100%] sm:flex-[0_0_50%] lg:flex-[0_0_33.333%]"
                >
                  <figure
                    data-testid={`testimonial-card-${i + 1}`}
                    className="h-full bg-white p-9 rounded-lg border border-[#2A2E7A]/8 shadow-[0_1px_2px_rgba(36,59,99,0.04)] flex flex-col gap-7"
                  >
                    <span className="font-heading text-6xl leading-[0.5] text-[#4B5CAB]/25 select-none" aria-hidden="true">
                      &ldquo;
                    </span>
                    <blockquote className="text-[16px] text-[#3A3F63] leading-[1.8] flex-1">
                      {t.quote}
                    </blockquote>
                    <figcaption className="flex items-center gap-4 pt-6 border-t border-[#2A2E7A]/8">
                      {t.logo ? (
                        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#F5F6FB] border border-[#2A2E7A]/8 overflow-hidden">
                          <img
                            src={t.logo}
                            alt={`${t.role} logo`}
                            className="h-8 w-8 object-contain"
                            loading="lazy"
                          />
                        </span>
                      ) : (
                        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#2A2E7A] text-white font-heading text-sm font-semibold">
                          {t.name.split(" ").map((w) => w[0]).slice(0, 2).join("")}
                        </span>
                      )}
                      <div>
                        <p className="font-heading font-semibold text-[15px] text-[#2A2E7A] leading-none">{t.name}</p>
                        <p className="mt-1.5 text-[13px] text-[#6B7688]">{t.role}</p>
                      </div>
                    </figcaption>
                  </figure>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Testimonials;
